import React from "react";

export const Content = ({ children }) => (
  <div className="overflow-y-auto absolute top-0 left-0 bg-background w-screen h-screen z-[-10] pt-24 pl-64 pr-8">
    {children}
  </div>
);
